import React, { useEffect, useState } from "react";
import { Sparkles } from "lucide-react";
import MotionReveal from "@/components/MotionReveal";
import api from "@/lib/api";
import { useLang } from "@/contexts/LangContext";

/** A single one-line quip from Andreas, rotating daily. */
const AndreasTip = () => {
  const { t, lang } = useLang();
  const [tip, setTip] = useState("");

  useEffect(() => {
    let cancelled = false;
    api.get("/andreas/tip", { params: { lang } })
      .then((r) => { if (!cancelled) setTip((r.data?.tip || "").trim()); })
      .catch(() => {});
    return () => { cancelled = true; };
  }, [lang]);

  if (!tip) return null;
  return (
    <MotionReveal>
      <div
        className="mx-auto max-w-[1180px] px-5 sm:px-8 py-6 sm:py-8"
        data-testid="andreas-tip"
      >
        <div className="surface-card p-5 sm:p-6 flex items-start gap-4">
          <div className="w-10 h-10 rounded-full bg-foreground text-background flex items-center justify-center shrink-0 font-serif-display text-lg">
            A
          </div>
          <div className="min-w-0 flex-1">
            <p className="editorial-kicker inline-flex items-center gap-1.5 text-accent">
              <Sparkles className="w-3 h-3" />
              {t("home.tipOfTheDay") || "Andreas' tip of the day"}
            </p>
            <p className="mt-2 font-serif-display italic text-lg sm:text-xl leading-snug text-foreground/85">
              {tip}
            </p>
          </div>
        </div>
      </div>
    </MotionReveal>
  );
};

export default AndreasTip;
